// extracted by mini-css-extract-plugin
module.exports = {"comment-box":"comment-box___3oHmW","add-note-btn":"add-note-btn___3nwdy","display-text":"display-text___2d0GR"};